import React, { useMemo } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { usePlatform } from '../../context/PlatformContext';
import { createThemeTokens, createMuiTheme } from '../../theme';

/**
 * DynamicThemeProvider Component
 *
 * Applies tenant-specific theme configuration to the entire application.
 * Transforms API theme data into Material-UI theme using the theme adapter.
 *
 * Features:
 * - Automatic theme application based on active tenant
 * - Support for custom CSS injection
 * - Fallback to default theme when no theme is active
 * - Memoized for optimal performance
 */
const DynamicThemeProvider = ({ children }) => {
  const { currentTheme } = usePlatform();

  // Transform API theme data into design tokens
  const themeTokens = useMemo(() => {
    return createThemeTokens(currentTheme);
  }, [currentTheme]);

  // Create Material-UI theme from tokens
  const muiTheme = useMemo(() => {
    return createMuiTheme(themeTokens);
  }, [themeTokens]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default DynamicThemeProvider;
